import SanoftLogo192 from './images/sanoft_logo_192.png';
import SanoftLogo512 from './images/sanoft_logo_512.png';
import ScangleLogo192 from './images/scangle_logo_192.png';
import ScangleLogo512 from './images/scangle_logo_512.png';
import WeighvoxLogo192 from './images/weighvox_log_192.png';
import WeighvoxLogo512 from './images/weighvox_logo_512.png';
import YescloudLogo192 from './images/yesweigh_logo_192.png';
import YescloudLogo512 from './images/yesweigh_logo_512.png';

export const BACKEND_URL = process.env.REACT_APP_API_BASE_URL || 'https://api-pos-legacy-uat.sanoft.com/api';
// export const BACKEND_URL = process.env.REACT_APP_API_BASE_URL || 'https://api1.sanoft.com/api';
// export const BACKEND_URL = 'https://yscloud.in/backend/api';
// export const BACKEND_URL = 'http://localhost:8000/api';

export const STORAGE_KEYS = {
  TOKEN: 'x-auth-token',
  USER_ID: 'x-auth-user-id',
  SHOP_ID: 'x-selected-shop-id',
  FIRST_NAME: 'x-first-name',
  LAST_NAME: 'x-last-name',
  USERNAME: 'x-username',
  BILL_PRINTER_IP: 'x-bill-printer-ip',
  USER_TYPE: 'x-user-type',
  SHOP_NAME: 'x-shop-name',
  ACTIVE_TAB: 'x-active-tab',
  DONT_SHOW_OTHER_SHOPS_ON_ITEM_EDIT: 'x-dont-show-other-shops-on-item-edit',
  SIGNUP_SECRET: 'x-signup-key',
  MAC_ID: 'x-mac-id',
  SALES_REPORT_COLUMN_FILTER: 'x-sales-summary-filter-column',
  REGISTRSATION_KEY: 'x-registration-key',
  TAX_PREFERENCE: 'x-tax-preference',
  SELECTED_BARCODE_PRINTER: 'x-selected-barcode-printer',
  PURCHASE_DATA: 'x-purchase-data',
  SESSION_ID: 'x-session-id',
};

export const HEADERS = {
  AUTH: 'Authorization',
  SHOP_ID: 'shop-id',
  SESSION_ID: 'session-id',
};

export const GST_PREFERENCES = {
  0: 'No Tax',
  1: 'Exclude Tax',
  2: 'Include Tax',
};

export const USER_PERMISSIONS = {
  DENY: 'deny',
  READ: 'read',
  WRITE: 'write',
};

export const SUBSCRIPTION_TYPE = {
  FREE: 'free',
  BASIC: 'basic',
  STANDARD: 'standard',
  PREMIUM: 'premium',
};

export const PLAN_STATUS = {
  FREE: 'free',
  TRIAL: 'trial',
  PAID: 'paid',
};

export const SHOP_STATUS = {
  ACTIVE: 'active',
  DELETE_REQUESTED: 'delete-requested',
};

export const ROUTES = {
  LOGIN: '/login',
  RESET_PASSWORD: '/reset-password',
  SIGNUP: '/signup',
  PLANS: '/plans',
  PRICING: '/pricing',
  ADD_ONS: '/add-ons',
  PROCESS_PAYMENT: '/payment-processing',
  RENEW_PLAN: '/console/renew-plan',
  PRICING_COMPARISON: '/pricing-comparison',
  ANY: '/',
  CONSOLE: '/console',
  ONBOARDING: '/onboarding',
  APP_SETUP: '/app-setup',
  SHOP_CREATED: '/shop-created',
  PAYMENT_STATUS: '/payment-status',

  HOME: '/console/home',
  DASHBOARD: '/console/dashboard',
  SINGLE_SHOP_DASHBOARD: '/console/dashboard',
  MULTI_SHOP_DASHBOARD: '/console/all-branch-dashboard',
  ITEMS: '/console/items',
  ITEM_DETAILS: '/console/items/:itemId',
  CATEGORIES: '/console/categories',
  DEVICES: '/console/devices',
  TERMINALS: '/console/terminals',
  TERMINAL_SETTINGS: '/terminals/:terminalId',
  CUSTOMERS: '/console/customers',
  CUSTOMER_DETAILS: '/console/customers/:customerId',
  CUSTOMER_GROUP: '/console/customer-group/',
  SALES_PERSON: '/console/sales-person',
  TABLES: '/console/tables',
  MANAGE_SALES: '/console/sales',
  ESTIMATES: '/console/estimates',
  PURCHASE_HISTORY: '/console/purchase-history',
  NEW_PRODUCTION: '/console/new-production',
  PRODUCTION_HISTORY: '/console/production-history',
  NEW_PURCHASE: '/console/new-purchase',
  EDIT_PURCHASE: '/console/edit-purchase/:id',
  PURCHASE_RETURN_HISTORY: '/console/purchase-return-history',
  NEW_PURCHASE_RETURN: '/console/new-purchase-return',
  EDIT_PURCHASE_RETURN: '/console/edit-purchase-return/:id',
  DAMAGE_HISTORY: '/console/damage-history',
  NEW_DAMAGE: '/console/new-damage',
  STOCK_TRANSFER: '/console/stock-transfer/external',
  NEW_STOCK_TRANSFER: '/console/stock-transfer/external/new',
  EDIT_STOCK_TRANSFER: '/console/stock-transfer/external/:id',
  INTERNAL_STOCK_TRANSFER: '/console/stock-transfer/internal',
  NEW_INTERNAL_STOCK_TRANSFER: '/console/stock-transfer/internal/new',
  EDIT_INTERNAL_STOCK_TRANSFER: '/console/stock-transfer/internal/:id',
  ITEM_SUMMARY: '/console/report/item-summary',
  PROFIT_ITEM_SUMMARY: '/console/report/profit/item-summary',
  ITEMISED_BILL: '/console/report/sale-items',
  PROFIT_ITEMISED_BILL: '/console/report/profit/sale-items',
  BILL_SUMMARY: '/console/report/sale-summary',
  ESTIMATE_REPORT: '/console/report/estimate-summary',
  ORDER_TYPE_SALES_REPORT: '/console/report/order-type-summary',
  RETURNED_BILL_SUMMARY: '/console/report/returned-sale-summary',
  RETURNED_ITEM_SUMMARY: '/console/report/returned-item-summary',
  RETURNED_SALE_ITEM_SUMMARY: '/console/report/returned-sale-item',
  PROFIT_BILL_SUMMARY: '/console/report/profit/sale-summary',
  DAY_WISE_REPORT: '/console/report/day-wise',
  STAFF_SALES_REPORT: '/console/report/staff-sales',
  STAFF_PRODUCT_SALES_REPORT: '/console/report/staff-product-sales',
  CATEGORY_SALES_REPORT: '/console/report/category-sales',
  PROFIT_DAY_WISE_REPORT: '/console/report/profit/day-wise',
  CUSTOMER_OUTSTANDING_REPORT: '/console/report/customer-outstanding',
  CUSTOMER_PAYMENT_REPORT: '/console/report/customer-payment',
  ALL_PARTY_REPORT: '/console/report/all-party-report',
  STOCK_REPORT: '/console/stock-report',
  MANUAL_STOCK_ADJUSTMENT_REPORT: '/console/manual-stock-adjustment-report',
  STOCK_CHANGE_REPORT: '/console/stock-change-report',
  STOCK_SUMMARY: '/console/stock-summary',
  SERVICE_STAFF_REPORT: '/console/report/service-staff-summary',
  SERVICE_STAFF_ITEM_WISE_REPORT: '/console/report/service-staff-summary/:id/item-wise',
  SERVICE_STAFF_DETAILED_REPORT: '/console/report/service-staff-summary/:id/detailed',
  NC_SALES_REPORT: '/console/report/nc-sales-summary',
  NC_CUSTOMER_REPORT: '/console/report/customer-nc-report',
  ITEM_STOCK_EXPIRING_REPORT: '/console/report/expiring-item-stock',
  ITEM_STOCK_EXPIRED_REPORT: '/console/report/expired-item-stock',

  PAYMENT_MODE_REPORT: '/console/report/payment-mode',
  PURCHASE_SUMMARY: '/console/report/purchase-summary',
  PURCHASE_ITEM_SUMMARY: '/console/report/payment-item-summary',
  VENDON_PURCHASE_SUMMARY: '/console/report/vendor-summary',
  SALES_TAX_SUMMARY: '/console/report/sales-tax-summary',
  PURCHASE_TAX_SUMMARY: '/console/report/purchase-tax-summary',
  HSN_SUMMARY: '/console/report/hsn-summary',
  SHIFTS: '/console/shifts',
  SHIFT_SUMMARY: '/console/report/shift-summary/:shiftId',
  ORDER_ACTIONS: '/console/order-actions',
  SETTINGS: '/console/settings',
  SETTINGS_TAB: '/console/settings/:tab',
  SETTINGS_SUB_TAB: '/console/settings/:tab/:subTab',
  SUBSCRIPTION_PLANS: '/subscription-plans',
  PERMISSION_DETAIL: '/settings/shop-users/:id',
  PAYMENT_CALLBACK: '/subscription-plans/payment-callback',
  PAGE_404: '/page-404',
  EXPENSES: '/console/expenses',
  VENDORS: '/console/vendors',
  VENDOR_DETAILS: '/console/vendors/:vendorId',
  ONLINE_ORDERS: '/console/online-orders',
  ONLINE_ORDER_DETAILS: '/console/online-orders/:id',
  ACCOUNT_HEADS: '/console/account-heads',
  ACCOUNT_LEDGER: '/console/account-ledger',
  WAREHOUSES: '/console/warehouses',
  WAREHOUSE_STOCK: '/console/warehouses/:warehouseId/stock',
  FEEDBACK_MANAGEMENT: '/console/feedback',
  PUBLIC_FEEDBACK: '/:shopId(\\d+)/feedback',
};

export const CONFIGS = {
  MAX_IMAGE_SIZE: 101000,
  LOGO_MAX_SIZE: 202000,
};

export const plans = {
  standard: {
    monthly: {
      IN: {
        price: 320,
        plan_id: 'SANOFT_ANDROID_POS_STANDARD-INR-Monthly',
      },
      US: {
        price: 8,
        plan_id: 'SANOFT_ANDROID_POS_STANDARD-USD-Monthly',
      },
    },
    yearly: {
      IN: {
        price: 3200,
        plan_id: 'SANOFT_ANDROID_POS_STANDARD-INR-Yearly',
      },
      US: {
        price: 80,
        plan_id: 'SANOFT_ANDROID_POS_STANDARD-USD-Yearly',
      },
    },
  },
  premium: {
    monthly: {
      IN: {
        price: 500,
        plan_id: 'SANOFT_ANDROID_POS_PREMIUM-INR-Monthly',
      },
      US: {
        price: 12,
        plan_id: 'SANOFT_ANDROID_POS_PREMIUM-INR-Monthly',
      },
    },
    yearly: {
      IN: {
        price: 5000,
        plan_id: 'SANOFT_ANDROID_POS_PREMIUM-INR-Yearly',
      },
      US: {
        price: 120,
        plan_id: 'SANOFT_ANDROID_POS_PREMIUM-USD-Monthly',
      },
    },
  },
};

export const CONTACT_NUMBER = '919746693296';

export const PRINTER_TYPES = ['USB', 'Bluetooth', 'Sunmi', 'Network', 'Pine Labs', 'PDF', 'Whatsapp'];

export const INVOICE_FORMATS = [
  '3 Inch',
  '3 Inch Pine Labs',
  '3 Inch Image - English',
  '3 Inch Image - Multi languate',
  '3 Inch Sunmi',
  '2 Inch',
  '2 Inch Pine Labs',
  '2 Inch Image - English',
  '2 Inch image - Multi language',
  '2 Inch Sunmi',
];

export const KOT_FORMATS = [
  '3 Inch',
  '3 Inch Image - English',
  '3 Inch Pine Labs',
  '3 Inch Invoice',
  '3 Inch Image Invoice',
  '2 Inch',
  '2 Inch Pine Labs',
  '2 Inch Sunmi',
  '2 Inch Invoice',
];

export const BARCODE_PRINTER_TYPES = ['USB', 'Bluetooth', 'Network'];
export const BARCODE_PRINTER_FORMATS = ['38 X 25 [2 column]', '50 X 25', 'CUSTOM PRN'];
export const BARCODE_PRINTER_FORMATS_CUSTOM_PRN = 'CUSTOM PRN';

export const SUFFIX_OPTIONS = ['FID', 'SID'];

export const ORDER_TYPES = [
  { 'Dine In': 'DINE IN' },
  { 'Take Away': 'TAKE AWAY' },
  { Delivery: 'DELIVERY' },
  { Online: 'ONLINE' },
];

export const TAX_PREFERENCES = [
  { 'No Tax': 'No Tax' },
  { 'Excluding Tax': 'Excluding Tax' },
  { 'Including Tax': 'Including Tax' },
];

export const TAX_REGIONS = [
  { 'United Arab Emirates': 'UAE' },
  { 'Saudi Arabia': 'Saudi' },
  { Bahrain: 'BH' },
  { Oman: 'Oman' },
  { Malaysia: 'MY' },
  { India: 'India' },
];

export const INVOICE_LAYOUTS = {
  A4_FRONTEND: 'a4_frontend',
  A5_PORTRAIT_FRONTEND: 'a5_portrait_frontend',
  A5_LANDSCAPE_FRONTEND: 'a5_landscape_frontend',
  A4_BACKEND: 'a4_backend',
  A5_BACKEND: 'a5_backend',
  THREE_INCH: '3_inch',
};

export const TAX_TYPE = [{ GST: 'GST' }, { VAT: 'VAT' }, { IGST: 'IGST' }, { SST: 'SST' }];

export const ROUND_OFF_TYPE = [{ FLOOR: 'FLOOR' }, { CEIL: 'CEIL' }, { NEAREST: 'NEAREST' }];

export const THEME_CONFIG = {
  default: {
    name: 'sanoft',
    color: {
      primary: '#0e3166',
      secondary: '#052556',
      tertiary: '#9DA2FF',
      header: '#383FC1',
      sub_header: '#1F236B',
      bg_color: '#272C86',
      active: '#1F236B',
      active_bg: '#383FC1',
    },
    variable: {
      name: 'SANOFT',
      title: 'Sanoft POS | Best Retail And Restaurant POS Software For Small Business',
      logo512: SanoftLogo512,
      logo192: SanoftLogo192,
      phone: '919074511134',
      trn_label: 'GSTIN',
    },
  },
  'spos.scangle.in': {
    name: 'scangle',
    color: {
      primary: '#0e3166',
      secondary: '#052556',
      tertiary: '#9DA2FF',
      header: '#383FC1',
      sub_header: '#1F236B',
      bg_color: '#272C86',
      active: '#1F236B',
      active_bg: '#383FC1',
    },
    variable: {
      name: 'SANOFT',
      title: 'Sanoft POS | Best Retail And Restaurant POS Software For Small Business',
      logo512: ScangleLogo512,
      logo192: ScangleLogo192,
      phone: '919139000888',
      trn_label: 'GSTIN',
    },
  },
  'pos.weighvox.com': {
    name: 'weighvox',
    color: {
      primary: '#0e3166',
      secondary: '#052556',
      tertiary: '#9DA2FF',
      header: '#383FC1',
      sub_header: '#1F236B',
      bg_color: '#272C86',
      active: '#1F236B',
      active_bg: '#383FC1',
    },
    variable: {
      name: 'SANOFT',
      title: 'Sanoft POS | Best Retail And Restaurant POS Software For Small Business',
      logo512: WeighvoxLogo512,
      logo192: WeighvoxLogo192,
      phone: '971524295311',
      trn_label: 'VAT NO',
    },
  },
  'pos.yesweigh.in': {
    name: 'yesweigh',
    color: {
      primary: '#0e3166',
      secondary: '#052556',
      tertiary: '#9DA2FF',
      header: '#383FC1',
      sub_header: '#1F236B',
      bg_color: '#272C86',
      active: '#1F236B',
      active_bg: '#383FC1',
    },
    variable: {
      name: 'YES',
      title: 'Sanoft POS | Best Retail And Restaurant POS Software For Small Business',
      logo512: YescloudLogo192,
      logo192: YescloudLogo512,
      phone: '918803333444',
      trn_label: 'GSTIN',
    },
  },
};

export const COUNTRY_CONFIGRATION = {
  IN: { name: 'India', currency: '₹', code: 'IN', tax: 0.18, trial_days: 7 },
  SA: { name: 'Saudi Arabia', currency: 'SAR', code: 'SA', tax: 0, trial_days: 7 },
  OM: { name: 'Oman', currency: 'OMR', code: 'OM', tax: 0, trial_days: 7 },
  AE: { name: 'UAE', currency: 'AED', code: 'AE', tax: 0, trial_days: 7 },
  BH: { name: 'BH', currency: 'BHD', code: 'BH', tax: 0, trial_days: 7 },
  US: { name: 'US', currency: '$', code: 'US', tax: 0, trial_days: 7 },
  MY: { name: 'MY', currency: 'MYR', code: 'MY', tax: 0, trial_days: 7 },
};

export const DEFAULT_COUNTRY = 'IN';

export const DEFAULT_TRIAL_DAYS = 14;

export const DEFAULT_CURRENCY = '₹';

export const DEFAULT_TAX_PERCENTAGE = 0.18;

export const MEASURMENT_UNITS = [
  { unit: 'Kilogram', symbol: 'Kg' },
  { unit: 'Piece', symbol: 'Pcs' },
  { unit: 'Gram', symbol: 'g' },
  { unit: 'Liter', symbol: 'Ltr' },
  { unit: 'Milliliter', symbol: 'Ml' },
  { unit: 'Meter', symbol: 'm' },
  { unit: 'Centimeter', symbol: 'cm' },
  { unit: 'Foot', symbol: 'ft' },
  { unit: 'Inch', symbol: 'Inch' },
  { unit: 'Unit', symbol: 'Unit' },
  { unit: 'Box', symbol: 'Box' },
  { unit: 'Packet', symbol: 'Pkt' },
  { unit: 'Square meter', symbol: 'm3' },
  { unit: 'Square foot', symbol: 'ft2' },
  { unit: 'Carat', symbol: 'Carat' },
  { unit: 'Dozen', symbol: 'Dozen' },
  { unit: 'Bunch', symbol: 'Bunch' },
];

export const REGISTER_STEPS = ['signup', 'shop type', 'counter type', 'basic setup'];

const DEFAULT_SHOP_SETTINGS = {
  advanced_quantity_control: false,
  amount_spent_for_loyalty_point: 100,
  amount_with_three_fraction: false,
  barcode_printer_format: '38 X 25 [2 column]',
  barcode_printer_note: null,
  barcode_printer_type: 'USB',
  consolidated_kot_format: '3 Inch',
  consolidated_kot_printer_ip: null,
  counter_foil_with_invoice: false,
  currency_fraction_name: null,
  currency_name: null,
  enable_table_selection_pos: false,
  invoice_format: '3 Inch',
  invoice_no_next: 1,
  invoice_no_prefix: '2024/T1/',
  kitchen_kot_format: '3 Inch',
  kot_with_invoice_printer_ip: null,
  loyalty_point_conversion_rate: 1,
  order_types: null,
  order_with_full_payment_only: true,
  price_with_tax_in_invoice: true,
  print_invoice_on_payment_update: false,
  print_total_save_on_invoice: false,
  printer_type: 'USB',
  sales_sync_platform: null,
  sales_sync_token: null,
  sales_webhook_url: null,
  salesperson_login: false,
  shop_logo: null,
  show_mrp_column_on_invoice: false,
  show_payment_mode_on_invoice: true,
  show_payment_page: true,
  skip_payment_page_on_invoice: false,
  stock_availability_check_for_sale: false,
  tax_preference: 'Excluding Tax',
  tax_region: 'India',
  token_no_next: null,
  token_no_prefix: null,
};

export const SHOP_SETTINGS = {
  other: {
    ...DEFAULT_SHOP_SETTINGS,
  },
  fine_dining: {
    ...DEFAULT_SHOP_SETTINGS,
    enable_table_selection_pos: true,
  },
  pre_paid: {
    ...DEFAULT_SHOP_SETTINGS,
  },
  mini_mart: {
    ...DEFAULT_SHOP_SETTINGS,
    print_total_save_on_invoice: true,
    show_payment_mode_on_invoice: true,
    show_mrp_column_on_invoice: true,
  },
  delivery: {
    ...DEFAULT_SHOP_SETTINGS,
    order_with_full_payment_only: false,
  },
  take_away: {
    ...DEFAULT_SHOP_SETTINGS,
  },
};

export const SHOP_CATEGORIES = [{ restaurant: 'Restaurant' }, { supermarket: 'Supermarket' }, { other: 'Other' }];

export const SHOP_SUB_CATEGORIES = {
  restaurant: [{ 'fine-dining': 'Fine Dining' }, { 'pre-paid': 'Pre-paid' }, { other: 'Other' }],
  supermarket: [{ 'mini-mart': 'Mini Mart' }, { delivery: 'Delivery' }, { other: 'Other' }],
  other: [{ 'take-away': 'Take Away' }, { delivery: 'Delivery' }, { other: 'Other' }],
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const SelectFilterStyle = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 6.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const SANOFT_WEB_URLS = {
  PRIVECY_POLICY: 'https://www.sanoft.com/privacy-policy',
  TERMS: 'https://www.sanoft.com/terms-and-conditions',
  REFUND_POLICY: 'https://www.sanoft.com/refund-policy',
  CONTACT_US: 'https://www.sanoft.com/#contact-us',
};

export const DEFAULT_COUNTRY_CODE = 'IN';

export const THEME_SANOFT = 'sanoft';

export const ITEM_TYPES = {
  INVENTORY: 'INVENTORY',
  COMBO: 'COMBO',
  SERVICE: 'SERVICE',
  PRODUCTION: 'PRODUCTION',
};

export const REGISTRATION_TYPE = {
  NEW: 'new-shop',
  TRIAL: 'trial-shop',
  RENEWAL: 'renew-shop',
  FREE: 'free-shop',
};

export const REGISTRATION_CHANNEL = {
  ONLINE: 'online',
  KEY: 'key',
  ADMIN: 'admin',
};

export const ONLINE_ORDER_PROCESSING_TYPE = ['Automatic'];

export const ORDER_PAYMENT_COLLECTION_MODES = {
  FULL_PAYMENT: 'Full Payment',
  ADVANCE_PAYMENT: 'Advance Payment',
  NO_PAYMENT: 'No Payment',
};

export const ADVANCE_PAYMENT_TYPES = {
  FIXED: 'Fixed Amount',
  PERCENTAGE: 'Percentage',
};

export const DEFAULT_ORDER_PAYMENT_COLLECTION_MODE = 'FULL_PAYMENT';

export const ORDER_STATUS = {
  PENDING: 'Waiting',
  READY: 'Ready',
  COMPLETED: 'Completed',
};

export const BLOCKED_PASSWORDS = ['test12345', 'test123', 'test@123'];

export const PROD_FE_BASE_URL = 'https://admin.sanoft.com';
export const PROD_BACKEND_BASE_URL = 'https://api1.sanoft.com/api';

export const TAX_PREFERENCE = {
  INCLUDING_TAX: 'Including Tax',
  EXCLUDING_TAX: 'Excluding Tax',
  NO_TAX: 'No Tax',
};

export const OFFLINE_REASON = {
  CLOSED: 'Business Closed',
  MAINTENANCE: 'Under Maintenance – Updates in Progress',
  STAFF_UNAVAILABLE: 'Staffing or Operational Issues',
  HIGH_VOLUME: 'Temporarily Unavailable – Too Many Orders',
  PERSONAL: 'Offline for Personal/Emergency Reason',
  PAUSE: 'Taking a break from business operations.',
  COMPLIANCE: 'Temporarily closed due to legal or regulatory reasons.',
  RELOCATION: 'Shifting operations to a different place.',
  SEASONAL: 'Temporarily Closed – Seasonal Business',
};

export const DAYS_OF_WEEK = {
  SUN: 'Sun',
  MON: 'Mon',
  TUE: 'Tue',
  WED: 'Wed',
  THU: 'Thu',
  FRI: 'Fri',
  SAT: 'Sat',
};

export const CONTACT_DETAILS = {
  IN: {
    phone: '+919567453182 | +919746693296',
    email: 'support@sanoft.com',
    address: '2nd Floor, KKM City Centre, Areakode - Vazhakkad Road Jn, Areekode, Kerala 673639',
  },
  MY: {
    phone: '+60135105806',
    email: 'malaysia@sanoft.com',
    address: 'C-1-19, CAMERON FAIR,  Jalan Camelia, Tanah Rata,  39000 Tanah Rata, Pahang, Malaysia',
  },
};

export const PRODUCTS_TAG_SUGGESTIONS = [
  { key: 'Veg/Non-veg', values: ['Veg', 'Non-veg'] },
  { key: 'Pepsi/Coke', values: ['Pepsi', 'Coke'] },
  { key: 'Meat type', values: ['Chicken', 'Beef', 'Lamb'] },
  { key: 'Addons', values: ['Cheese', 'Fries', 'Extra Sauce'] },
  { key: 'Serves to how many people', values: ['1', '2', '4', '6', '8+'] },
  { key: 'Preparation time', values: ['5 min', '10 min', '15 min', '30 min', '1 hour+'] },
  { key: 'Cuisine', values: ['Indian', 'Chinese', 'Italian', 'Mexican'] },
];

export const CATEGORIES_TAG_SUGGESTIONS = [
  { key: 'Veg/Non-veg', values: ['Veg', 'Non-veg'] },
  { key: 'Preparation / Diet Tags', values: ['Grilled', 'Fried', 'Baked', 'Healthy', 'Gluten-Free', 'Keto-Friendly'] },
  { key: 'Cuisine', values: ['Indian', 'Chinese', 'Arabic', 'Italian', 'Continental', 'Low-Calorie'] },
];

export const ORDER_TYPE_LIST = [
  { key: 'DINE_IN', label: 'Dine In', icon: '🍽️' },
  { key: 'TAKE_AWAY', label: 'Take Away', icon: '🥡' },
  { key: 'DELIVERY', label: 'Online', icon: '💻' },
  { key: 'ONLINE', label: 'Delivery', icon: '🚚' },
];

export const SUPPORT_WHATSAPP_NUMBER = '919074511134';

export const BARCODE_SETTINGS = {
  '38 X 25 [2 column]': {
    code: `SIZE 81 mm, 25 mm
DIRECTION 0,0
REFERENCE 0,0
OFFSET 0 mm
SET PEEL OFF
SET CUTTER OFF
SET PARTIAL_CUTTER OFF
SET TEAR ON
CLS
CODEPAGE 1252
TEXT 348,184,"0",270,8,8,"<title>"
BAR 377,0, 3, 199
TEXT 620,184,"0",180,7,7,"<name>"
TEXT 395,129,"0",270,7,7,"MRP: <mrp>"
QRCODE 436,133,L,5,A,270,M2,S7,"<barcode>"
TEXT 546,121,"0",270,6,6,"<barcode>"
TEXT 592,140,"0",270,9,9,"SRP: <price>"

TEXT 27,184,"0",270,8,8,"<title>"
BAR 56,0, 3, 199
TEXT 299,184,"0",180,7,7,"<name>"
TEXT 74,129,"0",270,7,7,"MRP: <mrp>"
QRCODE 115,133,L,5,A,270,M2,S7,"<barcode>"
TEXT 225,121,"0",270,6,6,"<barcode>"
TEXT 271,140,"0",270,9,9,"SRP: <price>"
PRINT 1,1
CUT

`,
    column: 2,
  },
  '50 X 25': {
    code: `SIZE 50 mm, 25 mm
          GAP 3 mm, 0 mm
          SET RIBBON ON
          DIRECTION 0,0
          REFERENCE 0,0
          OFFSET 0 mm
          SET PEEL OFF
          SET CUTTER OFF
          SET TEAR ON
          CLS
          CODEPAGE 1252
          TEXT 375,190,"2",180,1,1,"<title>"
          TEXT 375,170,"1",180,1,1,"<name>"
          BARCODE 375,150,"128M",59,0,180,2,4,"!105<barcode>"
          TEXT 335,85,"1",180,1,1,"<barcode>"
          TEXT 90,70,"1",180,1,1,"TOTAL"
          TEXT 150,50,"2",180,1,2,"<total>"
          TEXT 375,25,"1",180,1,1,"<price>"
          PRINT 1,1`,
    column: 1,
  },
};

export const LANGUAGES = { en: 'English', ar: 'Arabic', hi: 'Hindi', ms: 'Malay', ta: 'Tamil' };

export const SALE_SOURCES = [
  { id: 'SANOFT_POS', label: 'Sanoft POS' },
  { id: 'SANOFT_CART', label: 'Sanoft Cart' },
  { id: 'SANOFT_ADMIN', label: 'Sanoft Admin' },
  { id: 'ZOMATO', label: 'Zomato' },
  { id: 'SWIGGY', label: 'Swiggy' },
];

export const ITEM_SORTING_OPTIONS = {
  QUANTITY_DESC: { value: 'QUANTITY_DESC', labelTxKey: 'most_sold' },
  QUANTITY_ASC: { value: 'QUANTITY_ASC', labelTxKey: 'least_sold' },
  ITEM: { value: 'ITEM', labelTxKey: 'item_name_sort' },
  CATEGORY: { value: 'CATEGORY', labelTxKey: 'category_name_sort' },
};

export const TRANSFER_STATUS = {
  DRAFT: 'Draft',
  TRANSIT: 'Transit',
  RECEIVED: 'Received',
  REJECTED: 'Rejected',
};

export const STATUS_COLOR_MAPPING = {
  DRAFT: 'default',
  TRANSIT: 'info',
  RECEIVED: 'success',
  REJECTED: 'error',
};

export const SALE_STATUS = {
  active: 'active',
  draft: 'draft',
  paid: 'paid',
};

export const SANOFT_DEALER = 'SANOFT';

export const CLARITY_EVENTS = {
  LOGIN: 'login',
  LOGIN_FAILED: 'login_failed',
  SIGN_UP: 'sign_up',
  SIGN_UP_FAILED: 'sign_up_failed',
  LOAD_HOME_PAGE: 'load_home_page',
  CREATE_ITEM: 'create_item',
  CREATE_ITEM_FAILED: 'create_item_failed',
  CREATE_CATEGORY: 'create_category',
  CREATE_CATEGORY_FAILED: 'create_category_failed',
  CREATE_PRICE_CATEGORY: 'create_price_category',
  CREATE_PRICE_CATEGORY_FAILED: 'create_price_category_failed',
};

export const PAPER_SIZE = {
  A4: 'A4',
  A5_VERTICAL: 'A5_VERTICAL',
  A5_HORIZONTAL: 'A5_HORIZONTAL',
  THERMAL_80MM: '80mm',
};

export const PRINT_TYPES = {
  SALE: 'SALE',
  ESTIMATE: 'ESTIMATE',
  REPORT: 'REPORT',
};

export const ERROR_CODES = {
  BATCH_RECORDS_EXIST: 'BATCH_RECORDS_EXIST',
};
